import { render } from "./FooterMobile.vue?vue&type=template&id=7fcf8fcd"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FooterMobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fcf8fcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fcf8fcd', __exports__)) {
    api.reload('7fcf8fcd', __exports__)
  }
  
  module.hot.accept("./FooterMobile.vue?vue&type=template&id=7fcf8fcd", () => {
    api.rerender('7fcf8fcd', render)
  })

}


export default __exports__